export const networkName = 'Moon Rabbit';
export const backendUrl = 'https://backend.hashlab.online/';
export const chainId = '0x500';
export const marketplaceContractAddress = '0x3632F8C56bA2732CB8B3136C4117890258157807';
export const rabbitsCollectionContractAddress = '0xb3Ba1D4E935F0d917E1eC7d19Ca657e29F4Ada5A';
export const TOKEN_NAME = 'AAA';

// export const marketplaceContractAddress = '0xDf8B5FE019017dCD6b0a6690146C6B6743e7AE98';
// export const rabbitsCollectionContractAddress = '0xaE1CB20aa53c8F752F69E32B6c2Fd79536D0Bd57';
// export const chainId = 4;

export const nullAddress = '0x0000000000000000000000000000000000000000';

export const AUCTION_TYPE = 'Auction';
export const FIX_TYPE = 'FixedPrice';

export const TokenSaleStatus = {
  SALE: 'SALE',
  STORAGE: 'STORAGE',
  USER_PROFILE: 'USER_PROFILE',
  SECONDARY_MARKET: 'SECONDARY_MARKET',
};

export const FIX_PRICE_NFT = 'FIX_PRICE_NFT';
export const AUCTION_PRICE_NFT = 'AUCTION_PRICE_NFT';
